import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { categoryList, countByCategory, getCategoryPath } from "@/utils/content";

export default function CategoryStrip() {
  return (
    <section className="w-full bg-background-100">
      <div className="mx-auto max-w-content px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="主题分类"
          title="按题材找瓜，更快对上号"
          desc="同一个热榜里可能同时混着好几件事。先选分类，再按时间线往下读，找起来更省事。"
        />
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {categoryList.map((category) => (
            <Link
              key={category.slug}
              to={getCategoryPath(category.slug)}
              className="group flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-secondary-300 md:p-5"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-700 transition-colors group-hover:bg-secondary-500 group-hover:text-background-50">
                <i className={`${category.icon} text-xl`}></i>
              </span>
              <span className="min-w-0 flex-1">
                <span className="flex items-center gap-2">
                  <span className="font-heading text-base font-semibold text-foreground-950">
                    {category.name}
                  </span>
                  <span className="rounded-md bg-background-200 px-1.5 py-0.5 text-xs text-foreground-600">
                    {countByCategory(category.slug)} 条
                  </span>
                </span>
                <span className="mt-1.5 block text-sm leading-relaxed text-foreground-600">
                  {category.desc}
                </span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}